import { render } from "./DeleteAccount.vue?vue&type=template&id=e3d41efc&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"

import "./DeleteAccount.vue?vue&type=style&index=0&id=e3d41efc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d41efc"]])

export default __exports__